module.exports = __webpack_public_path__ + "static/media/Neumorphism.5336038e.png";